import styled from "@emotion/styled";
import { Text } from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledSummaryContainerDiv = styled("div")({
  display: "flex",
  padding: "5px 0 5px 30px",
  alignItems: "center",
  gap: "5px",
  alignSelf: "stretch",
});

export const StyledSummaryLabelText = styled(Text)(({ theme }) => ({
  color: theme.palette.grey[500],
}));
